// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonWrapper } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import { buttonTransparent } from "@west/XDL/PreStyle/button";
import { xBaseTheme } from "@west/XDL/types";
import { color } from "@west/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        mergeCss: true,
        color: "primary",
        typographyProps: {
            size: 12,
            color: "common.white",
            css: css`
                letter-spacing: 0;
                line-height: 15px;
                margin: 0;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
            `,
        },
        iconProps: {
            size: 12,
            src: "X",
        },
        css: css`
            display: flex;
            flex-direction: row-reverse;
            border-radius: 0;
            padding: 6px 8px;
            min-height: initial;
            transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            margin-bottom: 0;
            & > ${ButtonWrapper} {
                ${buttonTransparent}

                margin-right: 6px;
                margin-top: 2px;
                min-height: initial;
                background: transparent;
                &:hover > ${IconWrapper} {
                    color: ${color("danger")};
                }
            }
        `,
    },
} as xBaseTheme["tag"];
